<div class="tw-flex tw-flex-col tw-gap-4">
  <h1 class="content-title tw-items-center tw-mb-0 tw-mt-0">Your Invitations</h1>

  <div *ngIf="orgs.length == 0">
    <app-alert alertType="info" class="tw-text-base">
      You successfully logged in, but you don't have access to any orgs.
      <p *ngIf="rowData?.length > 0" class="tw-mb-0">
        Accept an invitation to join an existing org, or contact your administrator if you require a
        new invitation.
      </p>
      <p *ngIf="rowData?.length == 0" class="tw-mb-0">
        There are currently no invitations associated with this account. If your company is already
        using Live Data, please ask your administrator to invite you to the account.
      </p>
    </app-alert>
  </div>

  <div class="container" width="100%" [ngClass]="{ 'tw-hidden': !rowData || rowData.length == 0 }">
    <ag-grid-angular
      style="height: 100%;"
      domLayout="autoHeight"
      [ngClass]="{ 'ag-theme-quartz': !(darkModeService.darkMode$ | async), 'ag-theme-quartz-dark': darkModeService.darkMode$ | async }"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [components]="components"
      [defaultColDef]="defaultColDef"
      enableCellTextSelection="true"
      ensureDomOrder="true"
      (gridReady)="onGridReady($event)"
      (selectionChanged)="onSelectionChanged($event)">
    </ag-grid-angular>
  </div>
</div>
